/**
 * Sidebar tabs hidden for the Social Campaign Assistant demo.
 * Page components and API routes stay in the codebase — remove an id here to show it again.
 */
export const DEMO_HIDDEN_NAV_IDS = new Set([
  'call-logs', // Çağrı Kayıtları (voice)
  'appointments', // Randevular (voice calendar)
  'campaigns', // Kampanyalar (in-app campaign CRUD; Bilgi Bankası covers RAG docs)
  'conversation-details', // Görüşme Detayları (voice transcripts under Entegrasyon)
  'social-inbox', // Sosyal Gelen Kutusu (in-app Meta DM inbox)
  'social-leads', // Sosyal Leads (in-app campaign lead list)
]);
